import React from 'react'
import { AppliedRestrictions as AppliedRestrictionsType } from '@/api/types'
import { Link } from '@tanstack/react-router'
import { CollapsibleSection } from '@/components/CollapsibleSection/CollapsibleSection'

type Props = {
  appliedRestrictions: AppliedRestrictionsType
}

function getTotalRemoved(removedCandidates: Record<string, number>) {
  return Object.values(removedCandidates).reduce((acc, count) => acc + count, 0)
}

export function AppliedRestrictions({ appliedRestrictions }: Props) {
  const { initialCandidates, removedCandidates, finalCandidates, removedTypesOtherMealDivisions } =
    appliedRestrictions

  return (
    <div
      style={{
        fontSize: '14px',
        lineHeight: '1.6',
        marginTop: '1rem',
        padding: '1rem',
        border: '1px solid #ddd',
        borderRadius: '8px',
        background: '#f9f9f9',
        width: '40%',
      }}>
      <div style={{ marginBottom: '1rem' }}>
        <strong>Initial candidates:</strong>{' '}
        <span style={{ fontWeight: 500 }}>{initialCandidates}</span>
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <div>
          <strong>Removed by meal types:</strong>{' '}
          <span style={{ fontWeight: 500 }}>{removedTypesOtherMealDivisions}</span>
        </div>
        <div style={{ fontSize: 'small', color: 'gray' }}>
          Recipes with the same meal types as the remaining recipes selected for this meal are
          removed to avoid similar recipes being selected
        </div>
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <strong>{`Removed by rules: ${getTotalRemoved(removedCandidates)}`}</strong>
        <div style={{ marginTop: '0.5rem' }}>
          {Object.entries(removedCandidates).map(([rule, count]) => (
            <div
              key={rule}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '2px 0',
                color: count > 0 ? '#c0392b' : '#555',
              }}>
              <span>{rule}</span>
              <span>{count}</span>
            </div>
          ))}
        </div>
      </div>

      <CollapsibleSection
        label={`Final candidates (${Object.keys(finalCandidates).length})`}
        labelStyle={{ marginTop: '1rem', color: '#2c3e50', fontSize: '14px' }}>
        <div style={{ marginTop: '0.5rem' }}>
          {Object.entries(finalCandidates).map(([id, name]) => (
            <div key={id} style={{ padding: '2px 0' }}>
              <Link
                to="/recipes/$recipeId"
                params={{ recipeId: id }}
                style={{ color: '#2c3e50', textDecoration: 'underline' }}>
                {name}
              </Link>
            </div>
          ))}
        </div>
      </CollapsibleSection>
    </div>
  )
}
